import StyledIcon from "../StyledIcon";

const WaPlus = props => {
    return <StyledIcon width="25" height="25" viewBox="0 0 25 25" fill="none" {...props}>
        <path d="M24.5234 12.4385H0.523438" strokeWidth="2" strokeLinejoin="round" />
        <path d="M12.5234 0.438476L12.5234 24.4385" strokeWidth="2" strokeLinejoin="round" />
    </StyledIcon>
}

export default WaPlus;